<template>
    <div class="leftbar" id="exCollapsingNavbar">
        <div class="sidebar-brand lbPad border-bottom py-2" > <router-link to="/get-started" class="d-block"> <img src="../../../../static/website/images/logo.svg" class="logo d-block mx-auto" alt="logo"></router-link> </div>
        <div class="customleftDue-menu d-flex flex-column justify-content-between">
            <ul class="navbar-nav sidebar sidebar-light mt-2 lbPad">
                <li class="nav-item mt-2" :class="($route.path.includes('get-started'))?'active':''">
                    <router-link class="nav-link" to="/get-started"> <i class="icon icon-server"></i> <span>Get Started</span> </router-link>
                </li>
                <li class="nav-item mt-2" :class="($route.path.includes('daily-task'))?'active':''">
                    <router-link class="nav-link" to="/daily-task"> <i class="icon icon-dailyTask"></i> <span>Daily Task</span> </router-link>
                </li>
                <!-- <li class="nav-item mt-2" :class="($route.path.includes('dashboard'))?'active':''">
                    <router-link class="nav-link" to="/dashboard"> <i class="icon icon-dashboard-icon"></i> <span>Dashboard</span> </router-link>
                </li> -->
                <li class="nav-item" :class="($route.path.includes('appointment-list'))?'active':''">
                    <router-link class="nav-link" to="/appointment-list"> <i class="icon icon-consultation"></i> <span>Appointments</span> </router-link>
                </li>
                <li class="nav-item" :class="($route.path.includes('test-report'))?'active':''">
                    <router-link class="nav-link" to="/test-report"> <i class="icon icon-test-report"></i> <span>Test / Reports</span> </router-link>
                </li>
                <li class="nav-item" :class="($route.path.includes('prescription'))?'active':''">
                    <router-link class="nav-link" to="/prescription"> <i class="icon icon-prescription"></i> <span>Prescription</span> </router-link>
                </li>
                <li class="nav-item" :class="($route.path.includes('goals-and-actions'))?'active':''">
                    <router-link class="nav-link" to="/goals-and-actions"> <feather type="target" class="icon"></feather> <span>Goals And Actions</span> </router-link>
                </li>
                <li class="nav-item" :class="($route.path.includes('overall-health-data'))?'active':''">
                    <router-link class="nav-link" to="/overall-health-data"> <feather type="target" class="icon"></feather> <span>Overall Health Data</span> </router-link>
                </li>
                <!-- <li class="nav-item upcoming">
                    <a href="#" class="nav-link" > <i class="icon icon-health"></i> <span>Health Trackers</span> </a>
                </li>
                <li class="nav-item upcoming">
                    <a href="#" class="nav-link"> <i class="icon icon-diet"></i> <span>Recommended Diet</span> </a>
                </li>
                <li class="nav-item upcoming">
                    <a href="#" class="nav-link" > <i class="icon icon-yoga-pose"></i> <span>Nutrition & Supplements</span> </a>
                </li>
                <li class="nav-item upcoming">
                    <a href="#" class="nav-link" > <i class="icon icon-consultation"></i> <span>Exercise and Yoga</span> </a>
                </li> -->
            </ul>
            <!-- <ul class="bottomLogOut">
                <li class="nav-item">
                    <a class="nav-link px-3 border-bottom d-flex align-items-center" href="#" @click="$parent.logout()"> <feather type="log-out"></feather> <span class="ml-1">Logout</span> </a>
                </li>
                <li class="copyRight">
                    <p class="mb-0 py-2 px-3 copyRight">Copyright © 2021 <span class="themecolor">GiniHealth</span></p>
                </li>
            </ul> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'left-nav',
        data() {
            return {
                showNav : false
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/components/website/shared/left-nav.vue